import { createContext, useContext } from 'react';
import type { ObjektKennzahlen, EinheitUebersicht } from '../../../../lib/immobilien/objektDetail';
import type { Bereich, ObjektDetailDaten } from '../../../../lib/immobilien/useObjektDetail';
import type { VerwaltungsartKurz } from '../../../../lib/immobilien/sidebarNav';
import type { ObjektPanelKey } from '../../../../components/immobilien/objektPanels';

/** Gemeinsamer Zustand der Objektseite für Widgets und Panels. */
export interface ObjektSeitenWert {
  daten: ObjektDetailDaten;
  /** Fehler einzelner Bereiche (z. B. Zähler konnten nicht geladen werden) */
  fehler: Partial<Record<Bereich, string>>;
  name: string;
  adresse: string;
  verwaltungsart: VerwaltungsartKurz | null;
  uebersicht: EinheitUebersicht[];
  kennzahlen: ObjektKennzahlen;
  neuLaden: (...bereiche: (Bereich | 'objekt')[]) => void;
  oeffnePanel: (key: ObjektPanelKey, optionen?: { bearbeiten?: boolean }) => void;
  /** Wurde das Panel mit „Bearbeiten“ geöffnet (Drehkarte sofort umgedreht)? */
  panelBearbeiten: boolean;
  zuEinheiten: (einheitId?: string) => void;
}

export const ObjektSeitenKontext = createContext<ObjektSeitenWert | null>(null);

export function useObjektSeite(): ObjektSeitenWert {
  const wert = useContext(ObjektSeitenKontext);
  if (!wert) throw new Error('useObjektSeite außerhalb der Objektseite');
  return wert;
}
